import {
    ICheckboxData,
    IFeedbackFormData,
    INotificationFormData
} from "../Types";
import { ICard } from "./ICard";
import { v4 as uuid } from "uuid";
import { FeedbackType } from "./FeedbackType";
import { getBaseUrl } from "../../../configVariables";

export class FeedbackHeroCard implements ICard {
    id: string;
    userData: any;

    constructor(userData: any) {
        this.id = uuid();
        this.userData = userData
    };

    getId() : string {
        return this.id;
    };

    initCard() {
        return (
            {
                "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
                "version": "1.2",
                "type": "AdaptiveCard",
                "body": [
                    
                ],
                "actions": [
                    {
                        "type": "Action.Submit",
                        "id": "submit",
                        "data": {
                            "submit": "submit.CardNotificationFeedback",
                            "tenantId": this.userData.organization.id,
                            "userId": this.userData.profile.id,
                            "cardNotificationId": this.id
                        },
                        "title": "Enviar",
                        "style": "positive"
                    }
                ]
            }
        );
    };

    defaultCard() {
        return this.buildCard(
            "Título",
            "Subtítulo",
            getBaseUrl() + "/image/imagePlaceholder.png",
            "Resúmen",
            [{ id: uuid(), title: "opcion" }],
            FeedbackType.SimpleCompacto,
            false
        );
    };

    rebuildNotificationCard(data: INotificationFormData) { };

    rebuildFeedbackCard(data: IFeedbackFormData) {
        return this.buildCard(
            data.title,
            data.subtitle,
            data.imageLink,
            data.summary,
            data.checkboxes,
            data.selectedFeedbackType,
            data.requireComments
        );
    };

    buildCard(
        title: string,
        subtitle: string,
        imageLink: string,
        summary: string,
        checkboxes: ICheckboxData[],
        feedbackType: string,
        requireComments: boolean
    ) {
        const card: any = this.initCard();

        if (title)
            card.body.push(this.buildTextBlock(title, "large"));

        if (subtitle)
            card.body.push(this.buildTextBlock(subtitle, "medium"));
        
        if (imageLink)
            card.body.push(this.buildImage(imageLink));

        if (summary)
            card.body.push(this.buildTextBlock(summary, "medium"));

        if (checkboxes !== null && checkboxes !== undefined && checkboxes.length !== 0) {
            const resultCheckboxes: any[] = checkboxes.map(checkbox => ({
                title: checkbox.title,
                value: checkbox.title
            }));

            switch(feedbackType) {
                case FeedbackType.SimpleCompacto:
                    card.body.push(this.buildChoiceSet(resultCheckboxes, "compact", false));
                    break;
                case FeedbackType.SimpleExtendido:
                    card.body.push(this.buildChoiceSet(resultCheckboxes, "expanded", false));
                    break;
                case FeedbackType.Multiple:
                default:
                    card.body.push(this.buildChoiceSet(resultCheckboxes, "expanded", true));
                    break;
            };
        }

        if (requireComments)
            card.body.push(this.buildInputText());

        return card;
    };

    buildTextBlock(
        value: string | null,
        size: string
    ) {
        return {
            "type": "TextBlock",
            "wrap": true,
            "size": size,
            "text": value
        }
    };

    buildImage(imageUrl: string) {
        return {
            "type": "Image",
            "url": imageUrl
        };
    };

    buildChoiceSet(
        checkboxes: any,
        style: string,
        isMultiSelect: boolean,
    ) {
        return {
            "type": "Input.ChoiceSet",
            "id": "OptionSet",
            "style": style,
            "isMultiSelect": isMultiSelect,
            "choices": checkboxes
        }
    };

    buildInputText() {
        return {
            "type": "Input.Text",
            "id": "feedback",
            "placeholder": "Dejanos tu Opinion",
            "isMultiline": true
        }
    };
}